import { Helmet } from 'react-helmet-async'
import { getDeckMeta } from '@/decks/registry'

interface DeckHelmetProps {
  slug: string
}

const SITE_URL = 'https://gc-slides.web.app'

// Decks with a dedicated OG image in public/; others fall back to og-image.png.
const DECK_OG_IMAGES = new Set(['recsys-agent', 'bd-agent'])

export function DeckHelmet({ slug }: DeckHelmetProps) {
  const meta = getDeckMeta(slug)
  if (!meta) return null

  const fullTitle = `${meta.title} — GC Slides`
  const url = `${SITE_URL}/deck/${slug}`
  const ogImage = DECK_OG_IMAGES.has(slug)
    ? `${SITE_URL}/og-${slug}.png`
    : `${SITE_URL}/og-image.png`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={meta.ogDescription} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={meta.ogDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="628" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="GC Slides" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={meta.ogDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  )
}
